<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="flex flex-column gap-4 w-full">
    <div class="flex flex-column gap-2">
      <label for="email" class="font-medium text-900">Email report</label>

      <input
        pInputText
        id="email"
        name="email"
        type="text"
        placeholder="Enter email"
        class="w-full"
        formControlName="email"
      />

      <small class="text-600">
        Send the report directly to an email address.
      </small>

      <div *ngIf="form.invalid && form.touched">
        <p-message
          severity="error"
          text="Please enter a valid email"
        ></p-message>
      </div>

      <button
        pButton
        icon="pi pi-send"
        type="submit"
        label="Send Report"
        class="w-full"
        [loading]="loading"
      ></button>
    </div>

    <p-divider align="center">
      <span class="text-600 text-sm">OR</span>
    </p-divider>

    <div class="flex flex-column gap-2">
      <span class="font-medium text-900">Download report</span>

      <small class="text-600">
        Generate the file immediately and save it locally.
      </small>

      <button
        pButton
        icon="pi pi-download"
        type="button"
        label="Download Report"
        class="p-button-outlined w-full"
        [loading]="issuesService.loading"
        (click)="generate_excel_report()"
      ></button>
    </div>
  </div>
</form>